import { Typography } from 'antd'
import { TextProps } from 'antd/es/typography/Text'

type TextSize = 'sm' | 'md' | 'lg' | 'xl' | 'xxl'

type TextWeight = 400 | 500 | 600 | 700

type Props = {
  size?: TextSize
  weight?: TextWeight
  color?: string
} & TextProps

export const textSize = {
  sm: '10px',
  md: '12px',
  lg: '14px',
  xl: '16px',
  xxl: '18px'
}

export const Text = ({
  size = 'lg',
  weight = 500,
  color = 'inherit',
  children,
  className,
  ...props
}: Props) => {
  return (
    <Typography.Text
      className={className}
      style={{ fontSize: textSize[size], fontWeight: weight, color }}
      {...props}
    >
      {children}
    </Typography.Text>
  )
}
